import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';

const User = (props) => {
  const [userData, setUserData] = useState(null);
  const [shopData, setShopData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { mallId } = useParams();
  const { addToast } = useToasts();

  const [values, setValues] = useState({
    user_id: '', user_class: '1', mall_id: mallId, shop_id: '', cashier_no: '', user_name: '', user_short: '', password: '', upd_date: null, edit_flag: constClass.FLAG.OFF,
  });

  const refreshUser = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');

    const reg_params = {
      "site_id": props.match.params.siteId,
      "operator": "and",
      "where": [{ "site_id": props.match.params.siteId, "mall_id": mallId }]
    }

    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    // 店舗マスタ
    const shopData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${props.match.params.siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setShopData(shopData);
    data.sort((a, b) => a.user_id - b.user_id);
    setUserData(data);
  }, [props.match.params.siteId, mallId])

  // 登録ボタン：処理
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    //重複チェック
    if (data.upd_date === null && userData.some(usreData => usreData.user_id === data.user_id)) {
      window.alert('既に登録されているユーザIDです。');
      return;
    }
    //入力値チェック
    if (data.user_id === '') {
      window.alert('ユーザIDを入力してください。');
      return;
    }
    if (data.user_id.length > 20) {
      window.alert('ユーザIDは20文字以内で入力してください。');
      return;
    }
    if (data.user_id.trim().match(/\s+/g)) {
      window.alert('ユーザIDに空白文字は使用できません。');
      return;
    }
    if (!(String(data.user_id)).match(/^[0-9a-zA-Z]*$/)) {
      window.alert('ユーザIDは半角英数字で入力してください。');
      return;
    }
    if (data.upd_date === null && data.password === '') {
      window.alert('パスワードを入力してください。');
      return;
    }
    if (data.password && (8 > data.password.length || data.password.length > 20)) {
      window.alert('パスワードは8文字以上・20文字以下で入力してください。');
      return;
    }
    if (data.password && data.password.trim().match(/\s+/g)) {
      window.alert('パスワードに空白文字は使用できません。');
      return;
    }
    if (data.password && data.password.match(/[^a-zA-Z0-9\-/:;()\\&@".,?!'[\]{}#%^*+=_|~<>$`€£•]+/g)) {
      window.alert('パスワードは半角英数記号で入力してください');
      return;
    }
    if (data.user_name === '') {
      window.alert('ユーザ名を入力してください。');
      return;
    }
    if (data.user_name.length > 100) {
      window.alert('ユーザ名は100文字以内で入力してください。');
      return;
    }
    if (data.user_short === '') {
      window.alert('ユーザ名略称を入力してください。');
      return;
    }
    if (data.user_short.length > 50) {
      window.alert('ユーザ名略称は50文字以内で入力してください。');
      return;
    }
    if (data.user_class === constClass.USER_CLASS.STAFF && !data.shop_id) {
      window.alert('店舗を選択してください。');
      return;
    }
    if (data.user_class === constClass.USER_CLASS.MANAGER || data.user_class === constClass.USER_CLASS.MANAGERMALL) {
      data.shop_id = null;
      data.cashier_no = null;
    }
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id,
      user_class: data.user_class,
      user_name: data.user_name,
      user_short: data.user_short,
      password: data.password ? data.password : null,
      mall_id: data.mall_id ? data.mall_id : null,
      shop_id: data.shop_id ? data.shop_id : null,
      cashier_no: data.cashier_no ? data.cashier_no : null,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshUser();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    setValues({
      ...data,
      edit_flag: constClass.FLAG.ON
    });
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      user_id: '', user_class: '1', mall_id: mallId, shop_id: '', cashier_no: '', user_name: '', user_short: '', password: '', upd_date: null, edit_flag: constClass.FLAG.OFF,
    });
  }
  
  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.user_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.user_id === null || data.user_id === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-60`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  // 削除ボタン：処理
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!window.confirm(`ユーザ[${data.user_id}:${data.user_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: props.match.params.siteId,
      user_id: data.user_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshUser();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChange = (e) => {
    const target = e.target;
    var value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  // 初期実行トリガー
  useEffect(() => {
    async function fetchData() {
      await refreshUser();
    }
    return fetchData();
  }, [refreshUser]);

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="user_id">ユーザID</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="user_id" name="user_id" value={values.user_id} disabled={lockData || values.edit_flag === constClass.FLAG.ON } onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="password">パスワード</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="password" name="password" value={values.password} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="user_class">ユーザ区分</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <select className="form-control" name="user_class" id="user_class" value={values.user_class} onChange={handleChange}>
              <option value={constClass.USER_CLASS.MANAGER}>{constClass.USER_CLASS_NAME.MANAGER}</option>
              <option value={constClass.USER_CLASS.STAFF}>{constClass.USER_CLASS_NAME.STAFF}</option>
              <option value={constClass.USER_CLASS.MANAGERMALL}>{constClass.USER_CLASS_NAME.MANAGERMALL}</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="user_name">ユーザ名</label>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" id="user_name" name="user_name" value={values.user_name} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="user_short">ユーザ名略称</label>
          </div>
          <div className="col-5 text-left align-self-center">
            <input type="text" className="form-control" id="user_short" name="user_short" value={values.user_short} onChange={handleChange} />
          </div>
        </div>
        {values.user_class === constClass.USER_CLASS.STAFF &&
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="shop_id">店舗</label>
              </div>
              <div className="col-5 text-left align-self-center">
                <select className="form-control" name="shop_id" id="shop_id" value={values.shop_id} onChange={handleChange}>
                  <option value="">選択してください</option>
                  {shopData.filter(s => !values.mall_id || s.mall_id === Number(values.mall_id)).map((item) =>
                    <option key={item.shop_id} value={item.shop_id}>{item.shop_name}</option>
                  )}
                </select>
              </div>
            </div>
          </React.Fragment>
        }
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-2 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 mb-1 p-0 text-right">
        </div>
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  ユーザID
                </td>
                <td className="text-center align-middle">
                  ユーザ名
                </td>
                <td className="text-center align-middle">
                  更新日時
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {userData.map((data, idx) => (
                <tr key={data.user_id}>
                  {/* 施設ID */}
                  <td className="text-center align-middle">
                    {data.user_id}
                  </td>
                  {/* 施設名 */}
                  <td className="text-center align-middle">
                    {data.user_name}
                  </td>
                  {/* 更新日時 */}
                  <td className="text-center align-middle">
                    {data.upd_date}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {userData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {userData !== null && (renderList())}
      {userData !== null && (renderInput())}
      {/* {renderPreview()} */}
    </div>
  )
}

export default User;